import React from "react"
import { Card, CardBody } from "reactstrap"
import SimpleBar from "simplebar-react"
import RepairOfferListItem from "./ActivityListItems/RepairOffer"
import RepairAcceptOfferListItem from "./ActivityListItems/RepairAcceptOffer"
import RepairTrackingNumberInput from "./ActivityListItems/RepairTrackingNumberInput"
import RepairRequestCreated from "./ActivityListItems/RepairRequestCreated"
import RepairReportListItem from "./ActivityListItems/RepairReport"
import RepairAcceptReportListItem from "./ActivityListItems/RepairAcceptReport"
import RepairOrderInformationInput from "./ActivityListItems/RepairOrderInformationInput"
import RepairDeclinedInfo from "./ActivityListItems/RepairDeclinedInfo"
import RepairGoodsReceived from "./ActivityListItems/RepairGoodsReceived"
import RepairBuyerGoodsReceived from "./ActivityListItems/RepairBuyerGoodsReceived"

const Activity = ({ entry, myUser, reload }) => {
  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-start">
          <div className="me-2">
            <h5 className="card-title mb-4">Activity</h5>
          </div>
        </div>
        <SimpleBar className="mt-2">
          <ul className="verti-timeline list-unstyled">
            <RepairRequestCreated entry={entry} statusIndex={1} />
            <RepairOfferListItem
              entry={entry}
              myUser={myUser}
              statusIndex={2}
              reload={reload}
            />
            <RepairAcceptOfferListItem
              entry={entry}
              myUser={myUser}
              statusIndex={3}
              reload={reload}
            />

            <RepairOrderInformationInput
              entry={entry}
              myUser={myUser}
              statusIndex={4}
              reload={reload}
            />
            {/* 
            <RepairTrackingNumberInput
              entry={entry}
              myUser={myUser}
              statusIndex={5}
              reload={reload}
              trackingCount={1}
            /> */}

            <RepairGoodsReceived
              entry={entry}
              myUser={myUser}
              statusIndex={5}
              reload={reload}
            />

            <RepairReportListItem
              entry={entry}
              myUser={myUser}
              statusIndex={6}
              reload={reload}
            />

            <RepairAcceptReportListItem
              entry={entry}
              myUser={myUser}
              statusIndex={7}
              reload={reload}
            />

            {!entry?.dateDeclined && (
              <>
                <RepairTrackingNumberInput
                  entry={entry}
                  myUser={myUser}
                  statusIndex={8}
                  reload={reload}
                  trackingCount={2}
                />
                <RepairBuyerGoodsReceived
                  entry={entry}
                  myUser={myUser}
                  statusIndex={9}
                  reload={reload}
                  trackingCount={2}
                />
              </>
            )}

            <RepairDeclinedInfo entry={entry} myUser={myUser} />
          </ul>
        </SimpleBar>
      </CardBody>
    </Card>
  )
}

export default Activity
